import { render, staticRenderFns } from "./productGroup.vue?vue&type=template&id=d08a76ca&scoped=true&"
import script from "./productGroup.vue?vue&type=script&lang=js&"
export * from "./productGroup.vue?vue&type=script&lang=js&"
import style0 from "./productGroup.vue?vue&type=style&index=0&id=d08a76ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08a76ca",
  null
  
)

export default component.exports